import React from 'react'
import { useSearchResults } from '../../../../utils/Contexts/SearchResultsContext'
import { Col, Row } from 'react-bootstrap'
import { Fade } from 'react-awesome-reveal'
import ApptEditorTemplateShipmentDetails from '../../SchedulerComponents/ApptEditorTemplateComponents/ApptEditorTemplateShipmentDetails'
import CopyToClipboard from '../../../../utils/helpers/CopyToClipboard'
import ApptDetailsWithQuery from './ApptDetailsWithQuery'

const SearchResults = () => {

    const { searchResults, setSearchResults, searchState, setSearchState } = useSearchResults()

    const clearSearchResults = () => {
        setSearchResults(null)
        setSearchState('start')
    }

    if (!searchResults) { return null }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    if (searchState === 'loading') {
        return (
            <Col>
                <Fade>
                    <Row>
                        <div className="d-flex flex-row justify-content-center p-5">
                            <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>

                            </div>
                        </div>

                    </Row>
                </Fade>
            </Col>
        )
    }

    if (searchResults.length > 0) {
        return (
            <Col>
                <Fade>
                    <Row>
                        <div className='card mt-1 mb-1 border-dark'>
                            <div className='card-body'>
                                <div className='d-flex flex-row justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">
                                            Search Results
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-search ms-2" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                        </h5>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16" onClick={() => clearSearchResults()} style={{ cursor: 'pointer' }}>
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </div>
                                </div>

                                <div className='d-flex flex-column justify-content-center align-items-center'>
                                    {/* Search results  */}
                                    {searchResults.map((shipment, index) => {
                                        return (
                                            <div key={index} className="card m-2 border-dark" style={{ width: '40rem' }}>
                                                <div className='d-flex flex-row card-header justify-content-center'>
                                                    <div className="card-text">
                                                        {!shipment?.stops ?
                                                            <CopyToClipboard text={shipment.usercontrol} />
                                                            : null}
                                                        {shipment?.stops?.length ?
                                                            <CopyToClipboard text={shipment?.details?.orders.replace(/,/g, ', ')} />
                                                            : null}
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    {/* Single Shipment */}
                                                    {!shipment?.stops ?
                                                        <div>
                                                            <ApptEditorTemplateShipmentDetails shipment={shipment} isConsolidation={shipment?.isConsolidation} consolidationShipment={shipment?.consolidationShipment} />
                                                            <ApptDetailsWithQuery webquotecontrol={shipment.id} />
                                                        </div>
                                                        : null}

                                                    {/* Consolidation */}
                                                    {shipment?.stops?.length ?
                                                        <>
                                                            {shipment.details?.equipment?.length > 0 ? <span>   {shipment.details.equipment.map((equip, index) => {
                                                                return (<div className='d-flex flex-row justify-content-center'><span className="text-muted" key={index}>{capitalizeFirstLetter(equip)}&nbsp;</span></div>)
                                                            })}</span> : null}
                                                            <div className='d-flex flex-row justify-content-center'>
                                                                <span className="text-muted">{shipment.carrier.name}</span>
                                                            </div>
                                                            <div className='d-flex flex-column justify-content-center'>
                                                                {shipment.stops.map((stop, stopIndex) => {
                                                                    const stopWebquotecontrol = stop.orders.length > 0 ? stop.orders[0].id : null
                                                                    return (
                                                                        <>
                                                                            <div className="card m-2" key={stopIndex}>
                                                                                <div className="card-body">
                                                                                    <h6 className="card-subtitle mb-2">Stop {stop.stopNumber} ({stop.type}) - {stop.address.city}, {stop.address.state}</h6>

                                                                                    <div>Order(s): {stop.orders.map(order => order.id).join(', ')}</div>
                                                                                    {/* No pickup item display for Kwiktrip */}
                                                                                    {stop.type === "Pickup" && shipment.client.id !== "kwiktrip" ? (
                                                                                        <>
                                                                                            {stop?.orders?.map((order, i) =>
                                                                                                order?.handlingUnits?.map((hu, j) => (
                                                                                                    <div key={`${i}-${j}`}>
                                                                                                        {/* HU header */}
                                                                                                        <div className='mt-2' >
                                                                                                            {hu?.quantity} {capitalizeFirstLetter(hu?.packaging)}
                                                                                                        </div>
                                                                                                        {/* HU items */}
                                                                                                        {hu?.items?.map((item, k) => (
                                                                                                            <div key={`${i}-${j}-${k}`}>
                                                                                                                {item?.description}, {item?.weightTotal} {item?.weightUOM}
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                ))
                                                                                            )}

                                                                                        </>
                                                                                    ) : null}

                                                                                    {stop.type === "Delivery" ? (
                                                                                        <>
                                                                                            {stop?.orders?.map((order, i) =>
                                                                                                order?.handlingUnits?.map((hu, j) => (
                                                                                                    <div key={`${i}-${j}`}>
                                                                                                        {/* HU header */}
                                                                                                        <div className='mt-2' >
                                                                                                            {hu?.quantity} {capitalizeFirstLetter(hu?.packaging)}
                                                                                                        </div>
                                                                                                        {/* HU items */}
                                                                                                        {hu?.items?.map((item, k) => (
                                                                                                            <div key={`${i}-${j}-${k}`}>
                                                                                                                {item?.description}, {item?.weightTotal} {item?.weightUOM}
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                ))
                                                                                            )}

                                                                                        </>
                                                                                    ) : null}
                                                                                    <ApptDetailsWithQuery webquotecontrol={stopWebquotecontrol} onlyDisplayThisStopType={stop.type} />

                                                                                </div>

                                                                            </div>
                                                                            {stopIndex < shipment.stops.length - 1 && (
                                                                                <div className='d-flex flex-row justify-content-center'>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                                                                                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
                                                                                    </svg>
                                                                                </div>
                                                                            )}
                                                                        </>)
                                                                })}
                                                            </div>
                                                        </>
                                                        : null}
                                                </div>

                                                <div className='card-footer'>
                                                    <small className="text-muted" style={{ fontSize: "10px" }}>Id: <CopyToClipboard text={shipment.id} /></small>
                                                    {shipment?.stops?.length ?
                                                        <>
                                                            <div className='d-flex flex-row justify-content-center'>
                                                                <small className="text-muted">Multi Stop Shipment</small>
                                                            </div>
                                                        </>
                                                        : null}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Row>
                </Fade>
            </Col>
        )

    }
    if (searchResults.length === 0 && searchState === 'success') {
        return (
            <Col>
                <Fade>
                    <Row>
                        <div>No orders found.</div>
                    </Row>
                </Fade>
            </Col>
        )
    } else {
        return null
    }
}

export default SearchResults